import { render, staticRenderFns } from "./ListKilomCamion.vue?vue&type=template&id=5b73a19b&scoped=true&"
import script from "./ListKilomCamion.vue?vue&type=script&lang=js&"
export * from "./ListKilomCamion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b73a19b",
  null
  
)

export default component.exports